import { render, staticRenderFns } from "./Scopes.vue?vue&type=template&id=49be1e59&scoped=true&"
import script from "./Scopes.vue?vue&type=script&lang=js&"
export * from "./Scopes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49be1e59",
  null
  
)

export default component.exports